<template>
  <div class="w100">
    <table class="w100">
      <tr class="vertical-align-bottom ">
        <td>
          <div class="item-search-input-container">
            <input
              class="item-phone-number-input"
              type="text"
              :placeholder="InputPlaceHolderText"
              v-model="searchedValue"
            />
          </div>
        </td>
        <td class="vertical-align-bottom text-align-right w20">
            <button 
                v-on:click="onClickedSearch"
                class="icon-btn w100"> &#128269;
            </button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import DataSource from "../../data/DataSource";
import { Constants } from "../Constants";

export default {
  name: "SearchBar",
  props: {
    InputPlaceHolderText: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    searchedValue: "",
  }),
  methods: {
    onClickedSearch() {
      this.$emit("searchedQuery",this.searchedValue);
    }
  },
};
</script>

<style scoped src="../../assets/style/base.css"></style>
<style scoped>
.icon-btn {
  background-color: rgb(15, 141, 232);
  border: none;
  color: white;
  height: 40px;
  font-size: 16px;
  cursor: pointer;
  padding-top:2px ;
  border-radius: 8px;
}
.icon-btn:focus{
    outline: none;
}
</style>